import { InputPinCode } from 'components';
import { firebaseApp } from 'configs/firebase';
import {
  browserPopupRedirectResolver,
  browserSessionPersistence,
  getIdToken,
  initializeAuth,
  User,
} from 'firebase/auth';
import { Button, InputWraper, useForm } from 'modules';
import React from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { AuthRouteKeys } from 'routes/enums';
import { useCreatePinCodeMutation } from 'services';

import { formSchema } from './config';

const NewPasswordFeature = (): JSX.Element => {
  const auth = initializeAuth(firebaseApp, {
    persistence: browserSessionPersistence,
    popupRedirectResolver: browserPopupRedirectResolver,
  });

  const navigate = useNavigate();

  const { isLoading, mutateAsync } = useCreatePinCodeMutation();

  const handelChangePhoneNumber = () => {
    navigate(AuthRouteKeys.Login);
  };

  const handleCreateNewPass = async (values: {
    confirmNewPassword: string;
  }) => {
    const idToken = await getIdToken(auth.currentUser as User);

    try {
      const payload = {
        idToken,
        pinCode: values?.confirmNewPassword,
      };

      await mutateAsync(payload);

      toast.success(
        'Mật khẩu của bạn đã được cập nhật, vui lòng đăng nhập lại!',
      );

      navigate(AuthRouteKeys.Login, { replace: true });
    } catch (error) {}
  };

  const { handleSubmit, getInputProps } = useForm({
    structure: formSchema,
    onSubmit: handleCreateNewPass,
  });

  return (
    <div className='login-form'>
      <div className='login-form__logo'>
        <img
          style={{ width: '288px' }}
          className='login-form__logo__img'
          src='/assets/images/logo-white.png'
          alt=''
        />
      </div>

      <form onSubmit={handleSubmit} className='change-password__form'>
        <div className='change-password__form__input'>
          <InputWraper
            label={'Mật khẩu mới'}
            inputProps={getInputProps('newPassword')}
            component={InputPinCode}
          />

          <InputWraper
            label='Xác nhận lại mật khẩu'
            inputProps={getInputProps('confirmNewPassword')}
            component={InputPinCode}
          />
        </div>

        <div className='login-form__actions'>
          <Button
            label='Xác nhận mật khẩu'
            type='submit'
            buttonType='success'
            isLoading={isLoading}
          />

          <Button
            label='Đổi tài khoản'
            type='button'
            onClick={handelChangePhoneNumber}
            buttonType='primary-outline'
          />
        </div>
      </form>
    </div>
  );
};

export default NewPasswordFeature;
